export const generalInformationLabels = {
  dataPrecision: 'Data precision',
  stability: 'Stability',
  businessClimate: 'Business climate',
  countryRisk: 'Country risk',
};
